import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const HRVPage = lazy(() => import("./HRVPage.tsx"));

const HRVPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <HRVPage />
    </Suspense>
  );
};

export default HRVPageLazy;
